import React from 'react';
import { FileText, Newspaper, Camera, Users, Mail, Inbox, Plus, ChevronRight } from 'lucide-react';

export const DashboardOverview = ({ stats, onTabChange, onQuickAction }) => {
  if (!stats) return null;

  const cards = [
    { l: 'Actualites', v: stats.blog_posts, icon: FileText, c: 'bg-blue-500', t: 'blog' },
    { l: 'Programmes', v: stats.programs, icon: Newspaper, c: 'bg-emerald-500', t: 'programs' },
    { l: 'Galerie', v: stats.gallery_images, icon: Camera, c: 'bg-violet-500', t: 'gallery' },
    { l: 'Equipe', v: stats.team_members, icon: Users, c: 'bg-amber-500', t: 'team' },
    { l: 'Messages', v: stats.contacts, icon: Mail, c: 'bg-rose-500', t: 'contacts', sub: stats.unread_contacts ? `${stats.unread_contacts} non lus` : null },
    { l: 'Newsletter', v: stats.newsletter_subscribers, icon: Inbox, c: 'bg-cyan-500', t: 'newsletter' },
  ];

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Bienvenue sur HPD Admin</h1>
        <p className="text-gray-500 text-sm mt-1">Gerez l'ensemble du contenu de votre site web</p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map(s => (
          <div
            key={s.l}
            onClick={() => onTabChange(s.t)}
            className="bg-white rounded-2xl border border-gray-100 p-5 cursor-pointer hover:shadow-md transition-all group"
          >
            <div className="flex items-center justify-between mb-4">
              <div className={`w-10 h-10 ${s.c} rounded-xl flex items-center justify-center`}>
                <s.icon className="w-5 h-5 text-white" />
              </div>
              <ChevronRight className="w-4 h-4 text-gray-300 group-hover:text-gray-600 transition-colors" />
            </div>
            <p className="text-3xl font-bold text-gray-900">{s.v}</p>
            <p className="text-sm text-gray-500 mt-0.5">{s.l}</p>
            {s.sub && <p className="text-xs text-rose-500 mt-1 font-medium">{s.sub}</p>}
          </div>
        ))}
      </div>
      <div className="bg-white rounded-2xl border border-gray-100 p-6">
        <h3 className="font-semibold text-gray-900 mb-3">Actions rapides</h3>
        <div className="flex flex-wrap gap-2">
          <button onClick={() => onQuickAction('blog')} className="px-4 py-2 bg-blue-50 text-blue-700 rounded-lg text-sm font-medium hover:bg-blue-100 transition-colors flex items-center gap-2">
            <Plus className="w-4 h-4" />Nouvel article
          </button>
          <button onClick={() => onQuickAction('gallery')} className="px-4 py-2 bg-violet-50 text-violet-700 rounded-lg text-sm font-medium hover:bg-violet-100 transition-colors flex items-center gap-2">
            <Camera className="w-4 h-4" />Ajouter photo
          </button>
          <button onClick={() => onQuickAction('team')} className="px-4 py-2 bg-amber-50 text-amber-700 rounded-lg text-sm font-medium hover:bg-amber-100 transition-colors flex items-center gap-2">
            <Users className="w-4 h-4" />Ajouter membre
          </button>
          <button onClick={() => onTabChange('contacts')} className="px-4 py-2 bg-rose-50 text-rose-700 rounded-lg text-sm font-medium hover:bg-rose-100 transition-colors flex items-center gap-2">
            <Mail className="w-4 h-4" />Voir messages
          </button>
        </div>
      </div>
    </div>
  );
};
